export default {
  inject: ['load'],
  data() {
    return {
      allResultBaseDataWithPatient: [],
      allResultBaseData: [],
    };
  },
  methods: {
    getAllResultBaseDatasWithPatientFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllResultBaseListWithPatientDispatch').then(() => {
        if (this.$store.state.resultBaseDataModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.allResultBaseDataWithPatient =
            this.$store.state.resultBaseDataModule.allResultBaseDataWithPatient;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.resultBaseDataModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.resultBaseDataModule.successFlag) {
                this.getAllResultBaseDatasWithPatientFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.resultBaseDataModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllResultBaseDatasWithPatientFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllActiveResultBaseList: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllResultBaseListDispatch', { isActive: true }).then(() => {
        if (this.$store.state.resultBaseDataModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.allResultBaseData = this.$store.state.resultBaseDataModule.allResultBaseData;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.resultBaseDataModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.resultBaseDataModule.successFlag) {
                this.getAllActiveResultBaseList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.resultBaseDataModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllActiveResultBaseList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.resultBaseDataModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
